import { useRef, useEffect } from "react";
import "@/App.css";
import ParticleBackground from "@/components/ParticleBackground";
import HeroSection from "@/components/HeroSection";
import MarqueeStrip from "@/components/MarqueeStrip";
import ImpactStats from "@/components/ImpactStats";
import ManifestoSection from "@/components/ManifestoSection";
import FeaturesSection from "@/components/FeaturesSection";
import SectorsStrip from "@/components/SectorsStrip";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

function App() {
  const videoRef = useRef(null);

  useEffect(() => {
    let raf;
    let ticking = false;

    function tick() {
      if (videoRef.current) {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const vh = window.innerHeight;
        const t = Math.min(1, scrollY / (vh * 0.6));
        videoRef.current.style.opacity = (0.23 * (1 - t)).toFixed(4);
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        raf = requestAnimationFrame(tick);
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#080C14] overflow-x-hidden">
      {/* Aurora blobs */}
      <div className="aurora-container">
        <div className="aurora-blob aurora-blob-1" />
        <div className="aurora-blob aurora-blob-2" />
        <div className="aurora-blob aurora-blob-3" />
        <div className="aurora-blob aurora-blob-4" />
      </div>

      {/* Fixed video background */}
      <div
        ref={videoRef}
        className="fixed inset-0 z-[2] pointer-events-none overflow-hidden"
        style={{ opacity: 0.23 }}
      >
        <video
          data-testid="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 min-w-full min-h-full object-cover"
          style={{ filter: "saturate(1.3) contrast(1.1)" }}
        >
          <source src="/hero-video-cropped.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_10%,#080C14_65%)]" />
      </div>

      {/* Particles */}
      <ParticleBackground />

      {/* Content */}
      <div className="content-layer">
        <HeroSection />
        <MarqueeStrip />
        <ImpactStats />
        <ManifestoSection />
        <FeaturesSection />
        <SectorsStrip />
        <FinalCTA />
        <Footer />
      </div>
    </div>
  );
}

export default App;
